import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=311c7565"
import script from "./sign-up.vue?vue&type=script&setup=true&lang=ts"
export * from "./sign-up.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports